import i18n from '@/utils/i18n';
import React from 'react';
import { AlertCardSkeleton } from '@/experiences/sales-portal/domain/insights/components/alert-card/alert-card-skeleton';
import { View, YStack } from '@usepepper/sprout-kit-ui';

const CARD_COUNT = 3;

export const InsightsMobileAlertFeedSkeleton: React.FC = () => (
  <YStack
    accessibilityLabel={i18n.t('loading')}
    accessibilityState={{ busy: true }}
    gap="$8"
  >
    {Array.from({ length: CARD_COUNT }, (_, cardIndex) => (
      <View
        backgroundColor="$bgPrimaryDefault"
        borderColor="$borderPrimary"
        borderRadius="$12"
        borderWidth={1}
        key={cardIndex}
        overflow="hidden"
      >
        <AlertCardSkeleton />
      </View>
    ))}
  </YStack>
);
